import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
//serviceWorkerRegistration.register();

serviceWorkerRegistration.register({
  onSuccess: () => {console.log("SUCCESS REGISTRATION")},
  onUpdate: registration =>{
    clearCacheToUpdateInLatestRelease()
},
});

//serviceWorkerRegistration.unregister();


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

function clearCacheToUpdateInLatestRelease(){
   
  if (caches) {
    //clear cache to apply new production codes if has new release
    caches.keys().then((names) => {
      for (const name of names) {
        caches.delete(name);
      }
    });
    alert("New production release.")
   window.location.reload();
   
  }

}
